import React from 'react';

function Report() {
  return (
    <svg
      className="w-6 h-6 fill-current"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M17 19.22H5V7h7V5H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-7h-2v7.22z" />
      <path d="M19 2h-2v3h-3c.01.01 0 2 0 2h3v2.99c.01.01 2 0 2 0V7h3V5h-3V2zM15 9H7v2h8V9zM7 12v2h8v-2H7zM15 15H7v2h8v-2z" />
    </svg>
  );
}

export default Report;
